module.exports = __webpack_public_path__ + "img/replay_black.620d872d.svg";